import { useEffect } from 'react';
import Modal from '../Common/Modal';
import EmiCardSelection from '../EmiCardSelection';

const EmiModal = (props) => {
  useEffect(() => {
    if (props.open) {
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflowY = '';
    }
  }, [props.open]);

  return (
    <Modal
      visible={props.open}
      customStyles={{
        padding: 0,
        maxWidth: 672,
        maxHeight: '600px',
        height: '100%',
        overflowY: 'auto',
      }}
      animation={'slideUp'}
      className="bottom-modal"
      onClose={props.onClose}
    >
      <div className="emiModal">
        <EmiCardSelection />
      </div>
    </Modal>
  );
};

export default EmiModal;
